import FilterRadioButton from '../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../components/FilterRadioButtonsContainer';
import { TabsOptionsType } from '../types';

interface TabsOptionsI {
  activeTab: TabsOptionsType;
  handleChangeActiveTab: (selectedTab: TabsOptionsType) => void;
  tabsDisabled: string[];
}

export default function TabsOptions({ activeTab, handleChangeActiveTab, tabsDisabled }: TabsOptionsI) {
  return (
    <FilterRadioButtonsContainer>
      <FilterRadioButton onClick={() => handleChangeActiveTab('routingRules')} selected={activeTab === 'routingRules'}>
        Regras de Roteirização
      </FilterRadioButton>
      <FilterRadioButton onClick={() => handleChangeActiveTab('generalSettings')} selected={activeTab === 'generalSettings'}>
        Geral
      </FilterRadioButton>
      <FilterRadioButton onClick={() => handleChangeActiveTab('myLink')} selected={activeTab === 'myLink'} disabled={tabsDisabled.includes('myLink')}>
        My-Link
      </FilterRadioButton>
      <FilterRadioButton onClick={() => handleChangeActiveTab('accessControlAffreightment')} selected={activeTab === 'accessControlAffreightment'} disabled={tabsDisabled.includes('accessControlAffreightment')}>
        Fretamentos
      </FilterRadioButton>
      <FilterRadioButton onClick={() => handleChangeActiveTab('apiIntegrations')} selected={activeTab === 'apiIntegrations'}>
        Integrações API
      </FilterRadioButton>
      <FilterRadioButton onClick={() => handleChangeActiveTab('emails')} selected={activeTab === 'emails'}>
        E-mails informativos
      </FilterRadioButton>
      <FilterRadioButton onClick={() => handleChangeActiveTab('customLogo')} selected={activeTab === 'customLogo'}>
        Logomarca
      </FilterRadioButton>
      <FilterRadioButton onClick={() => handleChangeActiveTab('financial')} selected={activeTab === 'financial'}>
        Financeiro
      </FilterRadioButton>
    </FilterRadioButtonsContainer>
  );
}
